







import mixins from 'vue-typed-mixins';
import { ShortcutMixin } from '@/main/mixins/shortcut';

import { BaseInput } from '#components/dms/common/baseInput';

export default mixins(BaseInput, ShortcutMixin).extend({
	name: 'DmsClose',
	methods: {
		close() {
			this.$emit('closeClick');
		},
		keyboardShortcutsHandler(shortcut: KeyboardEvent) {
			if (shortcut.key === 'Escape') {
				this.close();
			}
		},
	},
});
